import {
  CAR_DATA_MASTER_GET_PAY_BRANCH_OFFICES_BEGIN,
  CAR_DATA_MASTER_GET_PAY_BRANCH_OFFICES_SUCCESS,
  CAR_DATA_MASTER_GET_PAY_BRANCH_OFFICES_FAILURE,
  CAR_DATA_MASTER_GET_PAY_BRANCH_OFFICES_DISMISS_ERROR
} from './constants'
import { BFFAgent } from 'BFFAgent';

export function getPayBranchOffices(pay_company_id) {
  return async (dispatch) => {
    dispatch({
      type: CAR_DATA_MASTER_GET_PAY_BRANCH_OFFICES_BEGIN,
    });

    try {
      const res = await BFFAgent.Payments.getPayBranchOffices(pay_company_id)
      if (res.status === 200) {
        if (res.branchOffices.length > 0) {
          const payBranchOffices = res.branchOffices.sort((a, b) => {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
          })
          dispatch({
            type: CAR_DATA_MASTER_GET_PAY_BRANCH_OFFICES_SUCCESS,
            data: payBranchOffices
          })
        } else {
          dispatch({
            type: CAR_DATA_MASTER_GET_PAY_BRANCH_OFFICES_SUCCESS,
            data: []
          })
        }
      }
      else {
        dispatch({
          type: CAR_DATA_MASTER_GET_PAY_BRANCH_OFFICES_FAILURE,
          data: []
        })
        return
      }
    }
    catch (err) {
      dispatch({
        type: CAR_DATA_MASTER_GET_PAY_BRANCH_OFFICES_FAILURE,
        data: { error: err },
      });
      return err;
    }
  }
}

export function dismissGetPayBranchOfficesError() {
  return {
    type: CAR_DATA_MASTER_GET_PAY_BRANCH_OFFICES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CAR_DATA_MASTER_GET_PAY_BRANCH_OFFICES_BEGIN:
      return {
        ...state,
        getPayBranchOffices: true,
        getPayBranchOfficesError: null,
      };

    case CAR_DATA_MASTER_GET_PAY_BRANCH_OFFICES_SUCCESS:
      return {
        ...state,
        getPayBranchOffices: false,
        getPayBranchOfficesError: null,
        payBranchOffices: action.data
      };

    case CAR_DATA_MASTER_GET_PAY_BRANCH_OFFICES_FAILURE:
      return {
        ...state,
        getPayBranchOffices: false,
        getPayBranchOfficesError: action.data.error,
        payBranchOffices: []
      };

    case CAR_DATA_MASTER_GET_PAY_BRANCH_OFFICES_DISMISS_ERROR:
      return {
        ...state,
        getPayBranchOfficesError: null,
      };

    default:
      return state;
  }
}
